export const PRODUCTION: string = 'production';

export const SET_LANGUAGE: string = 'SET_LANGUAGE';
export const STORE_ERROR: string = 'STORE_ERROR';
export const CLOSE_ERROR: string = 'CLOSE_ERROR';
export const SHOW_SUCCESS: string = 'SHOW_SUCCESS';

export const SHOW_LOGIN: string = 'SHOW_LOGIN';
export const HIDE_LOGIN: string = 'HIDE_LOGIN';

export const DRAFTS_DATA: string = 'DRAFTS_DATA';
export const CLEAR_DRAFTS_DATA: string = 'CLEAR_DRAFTS_DATA';
export const AUTH_DATA: string = 'AUTH_DATA';
export const CLEAR_AUTH_DATA: string = 'CLEAR_AUTH_DATA';

export const APP_DATA: string = 'APP_DATA';
export const THEMES_DATA: string = 'THEMES_DATA';
export const THEME_DATA: string = 'THEME_DATA';
export const SURVEY_DATA: string = 'SURVEY_DATA';
export const FOOTER_DATA: string = 'FOOTER_DATA';
export const ANSWERS_PREVIEW_DATA: string = 'ANSWERS_PREVIEW_DATA';
export const ANSWERS_DATA: string = 'ANSWERS_DATA';
export const SEARCH_DATA: string = 'SEARCH_DATA';
export const TRANSLATIONS_DATA: string = 'TRANSLATIONS_DATA';

export const ALL_ANSWERS_DATA: string = 'ALL_ANSWERS_DATA';

export const HEADER_HEIGHT: number = 120;
export const HEADER_MENU_HEIGHT: number = 50;
export const MAX_WIDTH: number = 1170;
export const LEFT_CONTENT_MAX_WIDTH: number = 900;
export const SURVEY_MAX_WIDTH: number = 560;

export const MAX_TEXT_INPUT: number = 80;
export const MAX_IMAGE_DESCRIPTION: number = 200;
export const MAX_TEXT_AREA_INPUT: number = 10000;

export const FOOTER_CONTAINER_HEIGHT: number = 128;
export const FOOTER_HEIGHT: number = 100;

export const EMUZEJS_URL: string = 'https://emuzejs.lnvm.lv/stasti';
